import React from "react";
import ExamPanel from "./ExamPanel";

export default function SectionPage() {
  return (
    <ExamPanel
      eyebrow="Current part"
      title="Speaking and Writing"
      instructions="This section contains spoken and written responses. Follow each screen carefully and use Next only when you are ready to submit the current response."
    >
      <div className="grid gap-4 sm:grid-cols-3">
        <div className="rounded-md border border-slate-200 bg-slate-50 p-4">
          <p className="text-xs font-bold uppercase text-gray-500">Section</p>
          <p className="mt-2 text-lg font-extrabold text-gray-900">
            Speaking and Writing
          </p>
        </div>
        <div className="rounded-md border border-slate-200 bg-slate-50 p-4">
          <p className="text-xs font-bold uppercase text-gray-500">Questions</p>
          <p className="mt-2 text-lg font-extrabold text-gray-900">31</p>
        </div>
        <div className="rounded-md border border-violet-100 bg-violet-50 p-4">
          <p className="text-xs font-bold uppercase text-violet-700">
            Time allowed
          </p>
          <p className="mt-2 text-lg font-extrabold text-violet-900">
            70 minutes
          </p>
        </div>
      </div>
    </ExamPanel>
  );
}
